var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRename = function SvgRename(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "17px",
    viewBox: "0 0 18 17",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Combined Shape")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document-creation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7,1.97175609e-13 C17.8656854,1.97145173e-13 18,0.134314575 18,0.3 L18,2.27142857 C18,2.437114 17.8656854,2.57142857 17.7,2.57142857 L16.285,2.571 L16.285,13.714 L17.7,13.7142857 C17.8656854,13.7142857 18,13.8486003 18,14.0142857 L18,15.9857143 C18,16.1513997 17.8656854,16.2857143 17.7,16.2857143 L12.3,16.2857143 C12.1343146,16.2857143 12,16.1513997 12,15.9857143 L12,14.0142857 C12,13.8486003 12.1343146,13.7142857 12.3,13.7142857 L13.714,13.714 L13.714,2.571 L12.3,2.57142857 C12.1343146,2.57142857 12,2.437114 12,2.27142857 L12,0.3 C12,0.134314575 12.1343146,1.97261556e-13 12.3,1.97175609e-13 L17.7,1.97175609e-13 Z M6.35825905,2.74553571 L10.433873,13.7142859 L7.82728809,13.7142859 L7.13420772,11.5973774 L3.30719872,11.5973774 L2.62165183,13.7142859 L0.0150669643,13.7142859 L4.07561392,2.74553571 L6.35825905,2.74553571 Z M5.22070322,5.71372773 L3.9550782,9.62360504 L6.49386173,9.62360504 L5.22070322,5.71372773 Z",
    id: "Combined-Shape",
    fill: "#9CA4B5",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRename, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rename.ae93f710.svg";
export { ForwardRef as ReactComponent };